import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDayOfMonth]',
})
export class DayOfMonthDirective {
  @Output() monthChange: EventEmitter<number> = new EventEmitter();
  input: HTMLInputElement;

  constructor(el: ElementRef) {
    this.input = el.nativeElement;
  }

  @HostListener('keydown', ['$event', '$event.keyCode'])
  onKeyDown($event: KeyboardEvent, keyCode) {
    const backspaceKey = 8;
    const endKey = 35;
    const homeKey = 36;
    const leftArrow = 37;
    const rightArrow = 39;
    const deleteKey = 46;

    const key: string = String.fromCharCode(keyCode);
    const cursorPos: number = this.input.selectionStart;
    const currentValue: string = this.input.value;
    const selectionLength: number = this.input.selectionEnd - this.input.selectionStart;

    $event.preventDefault();

    if (keyCode === endKey) {
      this.input.selectionStart = this.input.value.length;
      this.input.selectionEnd = this.input.value.length;
    }

    if (keyCode === homeKey) {
      this.input.selectionStart = 0;
      this.input.selectionEnd = 0;
    }

    if (keyCode === leftArrow) {
      if (this.input.selectionStart) {
        this.input.selectionStart = this.input.selectionStart - 1;
        this.input.selectionEnd = this.input.selectionStart;
      }
    }

    if (keyCode === rightArrow) {
      this.input.selectionStart = this.input.selectionStart + 1;
      this.input.selectionEnd = this.input.selectionStart;
    }

    if (keyCode === backspaceKey) {
      if (cursorPos !== 0 || selectionLength) {
        if (selectionLength) {
          this.input.value = currentValue.slice(0, cursorPos) + currentValue.slice(this.input.selectionEnd);
          this.input.selectionStart = cursorPos;
          this.input.selectionEnd = cursorPos;
        } else {
          this.input.value = currentValue.slice(0, cursorPos - 1) + currentValue.slice(this.input.selectionStart);
          this.input.selectionStart = cursorPos - 1;
          this.input.selectionEnd = cursorPos - 1;
        }
      }

      if (this.input.value === '') {
        this.monthChange.emit(undefined);
      } else {
        this.monthChange.emit(+this.input.value);
      }
    }

    if (keyCode === deleteKey) {
      if (selectionLength) {
        this.input.value = currentValue.slice(0, cursorPos) + currentValue.slice(this.input.selectionEnd);
      } else {
        this.input.value = currentValue.slice(0, cursorPos) + currentValue.slice(this.input.selectionStart + 1);
      }

      this.input.selectionStart = cursorPos;
      this.input.selectionEnd = cursorPos;

      if (this.input.value === '') {
        this.monthChange.emit(undefined);
      } else {
        this.monthChange.emit(+this.input.value);
      }
    }

    if (
      !isNaN(+key)
      && keyCode !== 32
      && keyCode !== 9
    ) {
      const newInputValue = currentValue.slice(0, cursorPos) + key + currentValue.slice(cursorPos + selectionLength);

      if ((+newInputValue > 0) && (+newInputValue <= 31)) {
        this.input.value = newInputValue;
        this.input.selectionStart = cursorPos + 1;
        this.input.selectionEnd = cursorPos + 1;
        this.monthChange.emit(+newInputValue);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/DayOfMonthDirective/dayOfMonth.directive.ts